import NotFound from './NotFound';
import NothingFound from './NothingFound';
import NoUploads from './NoUploads';
export default {
    NotFound,
    NoUploads,
    NothingFound,
};
